import { defaultMemoize } from 'reselect';

import {
    isResourceLoading,
    isResourceFailed,
    isResourceComplete,
} from './common';

const isCartItemsLoading = defaultMemoize(isResourceLoading);
const isCartItemsFailed = defaultMemoize(isResourceFailed);
const isCartItemsComplete = defaultMemoize(isResourceComplete);

const getCartItemsData = (state) => state.getIn(['app', 'cartItems']);

export {
    isCartItemsLoading,
    isCartItemsFailed,
    isCartItemsComplete,
    getCartItemsData,
};
